import { useEffect } from "react";
import { useSelector } from "react-redux";
import { retrieveLatestBooks } from "../../../redux/slice/latest-books-slice";
import { RootState, useAppDispatch } from "../../../redux/store";

import Card from "../../../widgets/cards";

const FeaturedBooks = () => {
  const { featuredBooksData } = useSelector(
    (state: RootState) => state.latestBooks
  );

  const dispatch = useAppDispatch();
  const numberOfBooks = 1;

  useEffect(() => {
    dispatch(retrieveLatestBooks(numberOfBooks));
  }, [dispatch]);

  var articles = featuredBooksData.map((item, index) => {
    return {
      date: item.availableDate,
      author: "",
      icon: "",
      category: "Featured Books",
      title: item.name,
      description: item.name,
      img: item.imageUrl,
      alt: item.name,
      showHomePage: true,
      articleURL: `/products/${item.nodeName}`
    };
  });

  var latestArticles = [
    {
      title: "Featured Books",
      link: "/education/books",
      article: articles,
    },
  ];

  return <Card cardData={latestArticles} />;
};

export default FeaturedBooks;
